module.exports = __webpack_public_path__ + "img/ic-map-plus-active.86de5be3.svg";